import { render, staticRenderFns } from "./FileAttachmentButton.vue?vue&type=template&id=2549a00c&scoped=true"
import script from "./FileAttachmentButton.vue?vue&type=script&lang=js"
export * from "./FileAttachmentButton.vue?vue&type=script&lang=js"
import style0 from "./FileAttachmentButton.vue?vue&type=style&index=0&id=2549a00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549a00c",
  null
  
)

export default component.exports